// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"3c6de581","377":"f5712cbe","409":"f5d69aed","806":"c05b08a4","881":"be2285d6","928":"4a2f1f76"}[chunkId] + ".chunk.js";
};